import AhmadAhmadLocales from "@/data/localization/AboutAhmad.locales";
import {
  FlexContainer,
  Heading1,
  Heading2,
  LI,
  Section,
  SectionArticle,
  UL,
  useLocales,
} from "@crescentapplications/react-ui";

export default function Lineage() {
  const l = useLocales();

  return (
    <Section bgColor="frame" id="lineage" padding="lg">
      <FlexContainer direction="column" gap="xl" fullWidth>
        <Heading1>{l(AhmadAhmadLocales.lineage)}</Heading1>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.paternal)}</Heading2>
          <UL>
            <LI>{l(AhmadAhmadLocales.paternal1)}</LI>
            <LI>{l(AhmadAhmadLocales.paternal2)}</LI>
            <LI>{l(AhmadAhmadLocales.paternal3)}</LI>
          </UL>
        </SectionArticle>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.maternal)}</Heading2>
          <UL>
            <LI>{l(AhmadAhmadLocales.maternal1)}</LI>
            <LI>{l(AhmadAhmadLocales.maternal2)}</LI>
            <LI>{l(AhmadAhmadLocales.maternal3)}</LI>
          </UL>
        </SectionArticle>
      </FlexContainer>
    </Section>
  );
}
